/**
 * Goal-related types and utilities for the PI Perform application
 */

export type GoalStatusType = 'no_status' | 'missed' | 'at_risk' | 'on_track' | 'achieved';

/**
 * @deprecated Use goalStatusTranslationKeys with tr() function instead for internationalization support.
 * Example: tr(goalStatusTranslationKeys[status])
 */
export enum GoalStatusesLabel {
  on_track = 'On Track',
  at_risk = 'At Risk',
  missed = 'Missed',
  no_status = 'No Status',
  achieved = 'Achieved',
}

/**
 * Centralized mapping of goal status types to their translation keys.
 * Use this with the tr() function for internationalized status labels.
 *
 * @example
 * const { tr } = useTranslation();
 * const statusLabel = tr(goalStatusTranslationKeys[status]);
 */
export const goalStatusTranslationKeys: Record<GoalStatusType, string> = {
  no_status: 'perform.goals.status.no_status',
  missed: 'perform.goals.status.missed',
  at_risk: 'perform.goals.status.at_risk',
  on_track: 'perform.goals.status.on_track',
  achieved: 'perform.goals.status.achieved',
};

export enum GoalIcons {
  ice_cream = 'ice-cream',
  comet = 'comet',
  kite = 'kite',
  hammer = 'hammer',
  apple_alt = 'apple-alt',
  bolt = 'bolt',
  heart = 'heart',
  badge_dollar = 'badge-dollar',
  flower_daffodil = 'flower-daffodil',
  cut = 'cut',
}

export enum GoalMetricTypeType {
  action_items = 'action_items',
  number = 'number',
  percent = 'percent',
  dollar_amount = 'dollar_amount',
  sub_goals = 'sub_goals',
}

export type GoalItem = {
  id: number;
  parentId: number;
  description: string;
  slug: string;
  name: string;
  workspaceSlug: string;
  icon: GoalIcons;
  date: string;
  assigneeId: number;
  assignerId: number;
  status: GoalStatusType;
  assignee: {};
  numCompleteActionItems: number;
  numIncompleteActionItems: number;
  complete: boolean;
  completedAt: Date;
  endDate: Date;
  nextCheckin: Date;
  position: number;
  privacySetting: string;
  reminderSetting: string;
  private: boolean;
  viewerId: number;
  resolutionNote: string;
  completedById: number;
  history: Array<{
    userName: string;
    goalName: string;
    assigneeName: string;
    userId: number;
    timestamp: number;
    changeType: string;
    before: string | number;
    after: string | number;
  }>;
  metricType: GoalMetricTypeType;
  metricCurrentValue: number;
  metricGoalValue: number;
  metricInitialValue: number;
  childrensCount: number;
  canEditActionItems: boolean;
};
